import { QueryKey, useQuery, UseQueryResult, UseQueryOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

type IBaseQueryOptions<T> =
  | Omit<UseQueryOptions<T, unknown, T, QueryKey>, 'queryKey' | 'queryFn'>
  | undefined;

function useBaseQuery<T>(
  queryKey: QueryKey,
  request: (signal: AbortSignal | undefined) => Promise<AxiosResponse<T, any>>,
  options?: IBaseQueryOptions<T>,
): UseQueryResult<T | undefined, unknown> {
  return useQuery({
    ...options,
    queryKey,
    queryFn: async ({ signal }) => {
      const response = await request(signal);
      return response.data;
    },
  });
}

export default useBaseQuery;
